import { CSSProperties } from 'react'

import { Spacings } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const EmptyContainer: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: toPx(Spacings.NODE_HORIZONTAL_PADDING),
}
